import { render, staticRenderFns } from "./HpuLoadingView.vue?vue&type=template&id=6ba561e2&scoped=true&"
import script from "./HpuLoadingView.vue?vue&type=script&lang=js&"
export * from "./HpuLoadingView.vue?vue&type=script&lang=js&"
import style0 from "./HpuLoadingView.vue?vue&type=style&index=0&id=6ba561e2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ba561e2",
  null
  
)

export default component.exports